import type {FormEditor} from "./FormEditor";

export type DateTimeFormat =
    "standard"
    | "date"
    | "time";

export type TimePolicyName =
    "date"
    /**
     * Time may be there but date-only entry is also supported
     */
    | "universal"
    /**
     * Time is always present. This is default for the picker.
     */
    |"datetime" ;

export type TP_DATE = 0;
/**
 * Time may be there but date-only entry is also supported
 */
export type TP_UNIVERSAL = 1;
/**
 * Time is always present. This is default for the picker.
 */
export type TP_DATETIME = 2;
export type TimePolicyCode = TP_DATE | TP_UNIVERSAL | TP_DATETIME;

export interface TimePolicyType {
    nameOf: TimePolicyName[],
    codeOf: TimePolicyNameCodeMapping,
    DATE: 0,
    UNIVERSAL: 1,
    DATETIME: 2
}

export interface TimePolicyNameCodeMapping {
    [key: string]: TimePolicyCode;
}

export const TimePolicy:TimePolicyType = {
    nameOf: ["date", "universal", "datetime"],
    codeOf: {
        date: 0,
        universal: 1,
        datetime: 2
    },
    DATE: 0,
    UNIVERSAL: 1,
    DATETIME: 2
}


export interface DateTime extends FormEditor {
    type: "datetime",
    format?: DateTimeFormat,
    empty?: string,
    timePolicy: TimePolicyCode,
    symbolic?: boolean
}
